"use strict";
import Login from "./Login.jsx";

export const auth = false;
export const title = "i18n:login.login";
export const Component = Login;
